<template>
  <a-locale-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-locale-provider>
</template>

<script>
import { AppDeviceEnquire } from '@/utils/mixin'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'
export default {
  mixins: [AppDeviceEnquire],
  data () {
    return {
      locale: enUS
    }
  }
}
</script>
<style>
  #app {
    height: 100%;
  }
</style>
